import React from 'react';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import { usePlaylistPreview } from '@hooks/API/UsePlaylist';

import NwDrawer from '@components/Gui/NwDrawer';
// { useState, useRef, useEffect }
import PlayListView from '@components/MediaDrawer/PlayListView';

//forceReloadPlaylist,

const PlayListPreviewDrawer = ({ playlist, contactID, onClose }) => {
    const { data: playlistData } = usePlaylistPreview(playlist.ID);

    return (
        <NwDrawer
            onClose={onClose}
            modalDrawer
            title={`${getContactName(playlist.ContactID || contactID)} / ${playlist.Name}`}
        >
            {playlistData && <PlayListView playlist={playlistData} />}
        </NwDrawer>
    );
};

export default PlayListPreviewDrawer;
